import { inject, Injectable, SecurityContext } from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';
@Injectable({
  providedIn: 'root',
})
export class SecureRedirectService {
  private domSanitizer = inject(DomSanitizer);

  sanitizeUrl(url: null): null;
  sanitizeUrl(url: string): string;
  sanitizeUrl(url: string | null): string | null;
  sanitizeUrl(url: string | null): string | null {
    if (!url) {
      return null;
    }
    return this.domSanitizer.sanitize(SecurityContext.URL, url);
  }
}
